import { render, staticRenderFns } from "./StrainForm.template.vue?vue&type=template&id=c29a8c62&scoped=true&"
var script = {}
import style0 from "./StrainForm.template.vue?vue&type=style&index=0&id=c29a8c62&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29a8c62",
  null
  
)

export default component.exports